<template>
  <div class="nx-channel-field">
    <v-layout row wrap>
      <slot></slot>
      <v-btn large flat icon color="primary" v-show="!unbound" :loading="loading">
        <v-icon medium>fa-link</v-icon>
      </v-btn>
      <v-btn large flat icon color="secondary" v-show="unbound" @click="bindField" :loading="loading">
        <v-icon medium>fa-unlink</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import Loadable from '@/mixins/loadable';
import Storable from '@/mixins/storable';

export default {
  name: 'nx-channel-field',
  inject: {
    $validator: '$validator',
    $getParentEditor: { default: null },
  },
  mixins: [Storable, Loadable],
  props: {
    field: {
      type: String,
      required: true,
    },
  },
  computed: {
    storePath() {
      return this.$getParentEditor().storePath;
    },
    unboundFields() {
      return this.getters.unboundFields;
    },
    bindFields() {
      return this.getters.bindFields;
    },
    currentChannel() {
      return this.state.currentChannel;
    },
    unbound() {
      return this.unboundFields.includes(this.field) && !this.bindFields.includes(this.field);
    },
    parentForm() {
      return this.$parent;
    },
    scope() {
      return this.$parentForm.scope;
    },
  },
  methods: {
    async bindField() {
      this.loadingStart();
      await this.dispatch('BIND_CHANNEL_FIELD', this.field);
      this.loadingFinish();
    },
    updateField(field, value) {
      this.$parentForm.updateField(field, value);
    },
  },
};
</script>
